import EventContainer from "./contianer/EventContainer";
import Fitness101 from "./contianer/Fitness101";
import { aesDecrypt } from "../../util/aes256";
import EventMetaContainer from "./contianer/EventMetaContainer";
import EventBrandContainer from "./contianer/EventBrandContainer";
import EventNaverContainer from "./contianer/EventNaverDaContainer";
import EventLeadPlanetContainer from "./contianer/EventLeadPlanetContainer";
import MessagePangEventContainer from "./contianer/MessagePangEventContainer";

const safeParseJson = (value) => {
    if (!value) {
        return null;
    }

    try {
        return JSON.parse(value);
    } catch (e) {
        return null;
    }
};

const EventPage = () => {
    const searchParams = new URLSearchParams(window.location.search);

    // 포털 사이트 광고 통한 유입 여부 확인 파라미터
    const adSrc= searchParams.get("ad_src");

    // 이벤트 구분을 위한 파라미터
    let eventCode = searchParams.get("evt_cd");
    let campaignId;
    if (adSrc) {
        let replacedAdSrc = adSrc.replace(/ /g, '+');
        let decryptedAdSrc = safeParseJson(window.atob(replacedAdSrc));
        if (decryptedAdSrc?.eventCode) {
            eventCode = decryptedAdSrc.eventCode;
        }
        if (decryptedAdSrc?.adPath) {
            eventCode = decryptedAdSrc.adPath;
        }
        if (decryptedAdSrc?.campaignId) {
            campaignId = decryptedAdSrc.campaignId;
        }
    }

    // 이벤트 진행 상황 파악을 위한 변수 설정
    if(!sessionStorage.getItem('evt_sess')) sessionStorage.setItem('evt_sess', 'init');

    // 카카오 또는 네이버 로그인 후 리다이렉트 시 전달되는 파라미터
    const code  = searchParams.get("code");
    let state = searchParams.get("state");

    let decryptedState = null;
    if(state) {
        state = state.replace(/ /g, '+');
        decryptedState = safeParseJson(aesDecrypt(state));
        if (decryptedState?.eventCode) {
            eventCode = decryptedState.eventCode;
        }
    }

    // 초기 이벤트 페이지의 경우 이벤트 구분 파라미터가 없었기 때문에 예외처리. 이벤트 종료 시 삭제 필요
    if(!eventCode) return (<EventContainer adSrc={adSrc} />)

    // 나머지 이벤트 페이지는 코드 값 구분
    else {
        switch (eventCode) {
            case 'LEADPLANET':
                return (<EventLeadPlanetContainer adSrc={adSrc} />)
            case 'fitness101':
                return (<Fitness101 code={code} state={state} decryptedState={decryptedState}/>);
            case 'bizting_meta':
                // 기존 코드명과 달리 네이버 DA 이벤트 페이지이며 메타 유입 랜딩과 별개다.
                return (<EventMetaContainer adSrc={adSrc} />);
            case 'bizting_brand':
            case 'bizting':
                return (<EventBrandContainer adSrc={adSrc} />);
            case 'NAVER_DA':
                return (<EventNaverContainer adSrc={adSrc} campaignId = {campaignId}/>);
            case 'MESSAGE_PANG':
                return (<MessagePangEventContainer />);
            default:
                return(<></>)
        }
    }
}

export default EventPage;
